import { render } from "./ScenicOverview.vue?vue&type=template&id=7fb4fce7&scoped=true"
import script from "./ScenicOverview.vue?vue&type=script&lang=js"
export * from "./ScenicOverview.vue?vue&type=script&lang=js"

import "./ScenicOverview.vue?vue&type=style&index=0&id=7fb4fce7&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb4fce7"]])

export default __exports__